<template>
    <v-col class="co-dados-principais">
        <v-row no-gutters class="d-flex align-center">
            <h3 class="primary--text">{{ $tc('pt_br.signatario', 2) }} ({{ signatarios.length }})</h3>

            <v-btn icon @click="exibirSignatarioCompleto = !exibirSignatarioCompleto">
                <v-icon color="primary">{{ exibirSignatarioCompleto ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
            </v-btn>
        </v-row>

        <v-row no-gutters class="d-flex align-center">
            <v-card class="full-size">
                <v-card-text class="d-flex px-5 justify-space-between">
                    <span>Incluir-me como {{ $tc('pt_br.signatario').toLowerCase() }}</span>
                    <v-switch class="ma-0 pa-0" v-model="incluirMe" color="primary" dense @change="addOrRemoveMe()" hide-details />
                </v-card-text>
            </v-card>
        </v-row>

        <v-row no-gutters class="d-flex align-center mt-5 importar-adicionar">
            <importar-signatarios-menu :abrir-dialogs="abrirDialogs" />

            <v-spacer />

            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon @click="adicionar">
                        <v-icon class="adicionar-signatarios" color="primary"> mdi-plus-circle</v-icon>
                    </v-btn>
                </template>

                <span>Adicionar {{ $tc('pt_br.signatario', 2) }}</span>
            </v-tooltip>
        </v-row>

        <v-row no-gutters class="d-flex align-center mt-5">
            <draggable
                tag="ul"
                :list="signatarios"
                v-bind="opcoesDraggable"
                class="draggable-wrapper d-flex pa-0"
                :class="podeMoverSignatario ? 'pode-arrastar' : ''"
                :disabled="!podeMoverSignatario"
            >
                <transition-group tag="li" class="transition-wrapper" type="transition">
                    <div v-for="(signatario, index) in signatarios" :key="signatario.key" class="d-flex align-center card-wrapper">
                        <div class="d-flex align-center dragging-icon-wrapper" :class="exibirIndicador(signatario.observador)">
                            <v-icon class="icone-ordem"> mdi-unfold-more-horizontal</v-icon>
                            <span>{{ index + 1 }}</span>
                        </div>
                        <card-dados-principais
                            :signatario="signatario"
                            :posicao-signatario="index"
                            class="full-size"
                            :pode-excluir-signatario="podeExcluirSignatario"
                            :papeis-signatario="papeisSignatario"
                            :tipos-assinatura="tiposAssinatura"
                            :exibir-signatario-completo="exibirSignatarioCompleto"
                            :signatarios-sugestoes="signatariosSugestoes"
                            @remover="remover"
                            @alternar-observador="adicionarObservador"
                        />
                    </div>
                </transition-group>
            </draggable>
        </v-row>

        <slot name="definir-ordem"></slot>

        <v-row v-if="!!observadores.length" no-gutters class="d-flex align-center mt-5">
            <h3 class="primary--text">Observadores ({{ observadores.length }})</h3>
        </v-row>

        <v-row no-gutters class="d-flex align-center mt-5 observadores-wrapper">
            <div v-for="(observador, index) in observadores" :key="observador.key" class="d-flex align-center full-size observadores">
                <card-dados-principais-observador
                    class="full-size"
                    :observador="observador"
                    :posicao-signatario="index"
                    :signatarios-sugestoes="signatariosSugestoes"
                    @remover="excluirObservador"
                    @validaTipoAssinatura="validaTipoAssinatura"
                    @alternar-observador="alternarObservadorDesabilitado"
                />
            </div>
        </v-row>

        <importar-signatarios-dialogs
            :papeis-signatario="papeisSignatario"
            :documentos-signatario="documentosSignatario"
            :abrir-dialogs="abrirDialogs"
            @adicionar-signatarios="adicionarSignatariosImportados"
        />
    </v-col>
</template>

<script>
import CardDadosPrincipais from './components/CardDadosPrincipais'
import CardDadosPrincipaisObservador from './components/CardDadosPrincipaisObservador'
import { actionTypes } from '@/commons/constants'
import ImportarSignatariosDialogs from './components/importarSignatarios/ImportarSignatariosDialogs'
import ImportarSignatariosMenu from './components/importarSignatarios/ImportarSignatariosMenu'
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
    name: 'DadosPrincipais',
    components: { ImportarSignatariosMenu, ImportarSignatariosDialogs, CardDadosPrincipais, CardDadosPrincipaisObservador },
    props: {
        signatarios: {
            type: Array,
        },
        observadores: {
            type: Array,
        },
        documentosSignatario: {
            type: Array,
            required: true,
        },
        papeisSignatario: {
            type: Array,
            required: true,
        },
        tiposAssinatura: {
            type: Array,
        },
        possuiOrdemAtiva: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            abrirDialogs: {
                dialogImportarSignatarios: false,
                dialogImportarGrupos: false,
            },
            incluirMe: false,
            exibirSignatarioCompleto: true,
            signatariosSugestoes: [],
        }
    },
    computed: {
        ...mapState(['login']),
        ehOrganizacaoConfiguracaoSignatarioExigirTokenAssinatura() {
            return this.login.organizacaoConfiguracao.geral.signatario.tokenAssinatura
        },
        opcoesDraggable() {
            return {
                animation: 330,
                group: 'novo-documento',
                disabled: false,
                ghostClass: 'sombra-arrastando',
            }
        },
        podeMoverSignatario() {
            return this.possuiOrdemAtiva
        },
        podeExcluirSignatario() {
            return this.signatarios.length === 1
        },
    },
    mounted() {
        this.buscarSignatariosSugestoes()
    },
    methods: {
        adicionarObservador({ posicaoSignatario, signatario }) {
            const copiaListaSignatarios = _.cloneDeep(this.signatarios)
            const copiaListaObservadores = _.cloneDeep(this.observadores)

            copiaListaSignatarios.splice(posicaoSignatario, 1)

            copiaListaObservadores.push({
                key: this.randomKey(),
                ...signatario,
            })

            if (copiaListaSignatarios.length === 0) {
                copiaListaSignatarios.unshift({
                    key: this.randomKey(),
                    nome: '',
                    telefone: '',
                    ddi: '55',
                    tipoAssinatura: 'ELETRONICA',
                    email: '',
                    papelId: 16,
                    enviarConviteSMS: false,
                    enviarTokenSMS: false,
                    representanteLegal: false,
                    observador: false,
                    solicitarTelefoneAssinatura: false,
                    solicitarSelfieAssinatura: false,
                    exigirTokenValidacao: this.ehOrganizacaoConfiguracaoSignatarioExigirTokenAssinatura
                })
            }

            this.$emit('alternar-observador', { signatarios: copiaListaSignatarios, observadores: copiaListaObservadores })
        },
        addOrRemoveMe() {
            if (this.incluirMe) {
                this.signatarios.unshift({
                    key: this.randomKey(),
                    incluirMe: true,
                    nome: this.login.usuarioOrganizacao.usuarioNome,
                    telefone: '',
                    ddi: '55',
                    tipoAssinatura: 'ELETRONICA',
                    email: this.login.usuarioOrganizacao.usuarioEmail,
                    papelId: 16,
                    enviarConviteSMS: false,
                    enviarTokenSMS: false,
                    representanteLegal: true,
                    observador: false,
                    solicitarTelefoneAssinatura: false,
                    exigirTokenValidacao: this.ehOrganizacaoConfiguracaoSignatarioExigirTokenAssinatura
                })
                this.mostrarNotificacaoSucesso(`${this.$tc('pt_br.signatario', 2)} adicionado com sucesso!`)
            } else {
                let indexRemove = this.signatarios.findIndex(signatario => signatario.incluirMe)

                if (indexRemove !== -1) {
                    this.signatarios.splice(indexRemove, 1)
                }

                if (!this.signatarios.length) {
                    this.signatarios.unshift({
                        key: this.randomKey(),
                        nome: '',
                        telefone: '',
                        ddi: '55',
                        tipoAssinatura: 'ELETRONICA',
                        email: '',
                        papelId: 16,
                        enviarConviteSMS: false,
                        enviarTokenSMS: false,
                        representanteLegal: true,
                        observador: false,
                        solicitarTelefoneAssinatura: false,
                        solicitarSelfieAssinatura: false,
                        exigirTokenValidacao: this.ehOrganizacaoConfiguracaoSignatarioExigirTokenAssinatura
                    })
                }
            }
        },
        adicionar() {
            this.$emit('adicionar-signatario')
        },
        adicionarSignatariosImportados(signatariosImportados) {
            const copiaListaSignatarios = _.cloneDeep(this.signatarios)
            const copiaListaObservadores = _.cloneDeep(this.observadores)

            signatariosImportados.forEach(signatario => {
                const newSignatario = {
                    key: this.randomKey(),
                    nome: signatario.nome,
                    telefone: signatario.telefone,
                    ddi: signatario.ddi,
                    skipFotoWpp: signatario.skipFotoWpp,
                    tipoAssinatura: signatario.tipoAssinatura,
                    email: signatario.email,
                    papelId: signatario.papelId,
                    enviarConviteSMS: false,
                    enviarTokenSMS: false,
                    representanteLegal: true,
                    observador: signatario.observador,
                    solicitarTelefoneAssinatura: signatario.solicitarTelefoneAssinatura ?? false,
                    solicitarSelfieAssinatura: signatario.solicitarSelfieAssinatura ?? false,
                    exigirTokenValidacao: signatario.exigirTokenValidacao
                }
                if (signatario.observador) {
                    copiaListaObservadores.unshift(newSignatario)
                } else {
                    copiaListaSignatarios.unshift(newSignatario)
                }
            })

            this.removerUltimoEmBranco(copiaListaSignatarios)
            this.$emit('alternar-observador', { signatarios: copiaListaSignatarios, observadores: copiaListaObservadores })
            this.mostrarNotificacaoSucesso(`${this.$tc('pt_br.signatario')}(s) adicionado(s) com sucesso!`)
        },
        async buscarSignatariosSugestoes() {
            let signatarios = await this.$store.dispatch(actionTypes.SIGNATARIO.BUSCAR_SIGNATARIOS_SUGESTOES)
            if (signatarios !== undefined) {
                this.signatariosSugestoes = signatarios.map(signatario => {
                    return signatario.email
                })
            }
        },
        exibirIndicador(signatarioObservador) {
            return this.possuiOrdemAtiva && !signatarioObservador ? 'indicador-ativo' : ''
        },
        ehSignatarioVazio(signatario) {
            let emailVazio = signatario.email === '' || signatario.email === undefined
            let telefoneVazio = signatario.telefone === '' || signatario.telefone === undefined

            return emailVazio && telefoneVazio
        },
        randomKey() {
            return new Date().getTime() + Math.floor(Math.random() * 10000).toString()
        },
        removerUltimoEmBranco(listaSignatarios) {
            if (listaSignatarios.length > 1) {
                let ultimoSignatario = listaSignatarios.at(-1)
                if (this.ehSignatarioVazio(ultimoSignatario)) {
                    listaSignatarios.pop()
                }
            }
        },
        alternarObservadorDesabilitado({ posicaoSignatario, observador }) {
            const copiaListaSignatarios = _.cloneDeep(this.signatarios)
            const copiaListaObservadores = _.cloneDeep(this.observadores)

            copiaListaObservadores.splice(posicaoSignatario, 1)

            copiaListaSignatarios.unshift({
                key: this.randomKey(),
                ...observador,
            })

            this.$emit('alternar-observador', { signatarios: copiaListaSignatarios, observadores: copiaListaObservadores })
        },
        excluirObservador({ posicaoSignatario }) {
            const copiaListaObservadores = _.cloneDeep(this.observadores)
            copiaListaObservadores.splice(posicaoSignatario, 1)

            this.$emit('alternar-observador', { observadores: copiaListaObservadores })
        },
        remover(signatario) {
            if (signatario.incluirMe) {
                this.incluirMe = false
            }

            this.$emit('remover-signatario', signatario)
        },
        validaTipoAssinatura() {
            this.$emit('validaTipoAssinatura')
        },
    },
}
</script>

<style lang="stylus">
.co-dados-principais
    .observadores-wrapper
        width 100%
        gap 20px

    .draggable-wrapper
        width 100%
        flex-direction column
        gap 20px

        .transition-wrapper
            display flex
            flex-direction column
            gap 20px

            .card-wrapper
                width 100%

                .dragging-icon-wrapper
                    color #999
                    font-size 18px
                    transition all 0.3s ease-in-out
                    width 0px
                    opacity 0
                    visibility hidden
                    margin-right 0

                    .icone-ordem
                        font-size 20px

                    &.indicador-ativo
                        width 33px
                        opacity 1
                        visibility visible
                        margin-right 11px

    .pode-arrastar
        &:hover
            cursor move

    .full-size
        width 100%

.sombra-arrastando
    opacity 0.5

@media (max-width: 900px)
    .co-dados-principais
        .importar-adicionar
            .co-importar-signatarios-menu
                .buscar-importar

                    .buscar-icone
                        font-size 19px !important

            .adicionar-signatarios
                font-size 25px !important
</style>
